export default __webpack_public_path__ + "media/copilotFreStep3.724cd66c.webp";